import React, { useState, useEffect } from 'react';
import { Fragment } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';

import { WebAPI } from '../../MedicareProAPI/API/WebAPI';
import { PlanRepository } from '../../MedicareProAPI/Repositories/PlanRepository';
import { Utilities } from '../../MedicareProAPI/Utilities/Utilities';
import CommissionSingle from '../Components/CommissionSingle';
import CommissionButton from '../Buttons/CommissionsButton';
import Loader from '../Components/Loader';
import StyledModal from '../Components/StyledModal';

export default function AgentAnalyticsSchedulePanel(props) {
  const scheduleDefaultMonthCount = 14;

  const webAPI = new WebAPI();
  webAPI.setAccessToken(props.userAccessToken);

  const individualPolicyRepository = new MedicareProAPI.IndPolicyRepository();
  individualPolicyRepository.setAccessToken(props.userAccessToken);

  const [visibleSections, setVisibleSections] = useState([]);

  const [commissionIncludePending, setCommissionIncludePending] = useState(false);

  const [commissionScheduleData, setCommissionScheduleData] = useState(null);

  const [commissionSchedule, setCommissionSchedule] = useState(null);
  const [commissionScheduleMonths, setCommissionScheduleMonths] = useState(null);
  const [commissionScheduleTotals, setCommissionScheduleTotals] = useState(null);
  const [commissionScheduleCompanyTotals, setCommissionScheduleCompanyTotals] = useState(null);

  const [commissionScheduleExporting, setCommissionScheduleExporting] = useState(false);
  const [selectedRenewalStartDate, setSelectedRenewalStartDate] = useState(null);
  const [selectedRenewalEndDate, setSelectedRenewalEndDate] = useState(null);
  const [editPolicyModalShow, setEditPolicyModalShow] = useState(false);
  const [editedPolicy, setEditedPolicy] = useState(null);

  const [isUpdating, setIsUpdating] = useState(false);
  const [editingPolicyData, setEditingPolicyData] = useState({});

  const [fetchPolicy, setFetchPolicy] = useState(null);

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  const handleFetchPolicy = (indId, policyId, planName, indName) => {
    setEditPolicyModalShow(true);

    const editingPolicyData = {
      indId: indId,
      policyId: policyId,
      planName: planName,
      indName: indName,
    };
    setEditingPolicyData(editingPolicyData);
    individualPolicyRepository.getIndPolicy(indId, policyId).then((response) => {
      const policy = {
        policyPremium: parseFloat(response.getPolicyPremium().replace('$', '')),
        policyComPrem: parseFloat(response.getPolicyComPrem().replace('$', '')),
      };
      setEditedPolicy(policy);
    });
  };

  const handlePolicyEdited = (e) => {
    console.log(e.target.value);
    let _edited = { ...editedPolicy };
    _edited[e.target.name] = parseFloat(e.target.value.replace('$', '')) || 0;

    setEditedPolicy(_edited);
  };

  const handleUpdatePolicy = (indId, policyId, editedPolicy) => {
    setIsUpdating(true);
    individualPolicyRepository.updateIndPolicy(indId, policyId, editedPolicy).then((response) => {
      console.log('finished updateing');
      setEditedPolicy(null);
      setEditPolicyModalShow(false);
      setIsUpdating(false);
      handleSave();
    });
  };

  const fetchCommissionSchedule = () => {
    webAPI.getUserCommissionsSchedule(props.userId).then((commissionSchedule) => {
      setCommissionScheduleData(commissionSchedule);
    });
  };

  // Get User Plan types on first load
  useEffect(() => {
    fetchCommissionSchedule();
  }, []);

  const handleSave = () => {
    setCommissionScheduleMonths(null);
    setCommissionSchedule(null);
    setCommissionScheduleTotals(null);
    setCommissionScheduleCompanyTotals(null);

    fetchCommissionSchedule();
  };

  const toggleVisibleSection = (name) => {
    let newVisibleSections = [...visibleSections];

    let currentSectionIndex = newVisibleSections.findIndex((section) => section === name);

    if (currentSectionIndex >= 0) {
      newVisibleSections.splice(currentSectionIndex, 1);
    } else {
      newVisibleSections.push(name);
    }
    console.log(newVisibleSections);
    setVisibleSections(newVisibleSections);
  };

  const handleGetUserCommissionScheduleExport = (event) => {
    setCommissionScheduleExporting(true);

    webAPI.getUserCommissionsScheduleExport(props.userId).then((response) => {
      setCommissionScheduleExporting(false);

      const form = document.createElement('a');
      form.href = response['url'];

      document.body.appendChild(form);
      form.click();
    });
  };

  const handleSelectRenewalStartDate = (event) => {
    setCommissionSchedule(null);
    const selectedMonth = event.target.value;
    console.log(selectedMonth);
    setSelectedRenewalStartDate(selectedMonth); // Append "-01" for day

    let selectedRenewalEndDate = new Date(selectedMonth);
    selectedRenewalEndDate.setMonth(selectedRenewalEndDate.getMonth() + 14);

    webAPI
      .getUserCommissionsSchedule(props.userId, {
        scheduleStart: selectedMonth,
        scheduleEndDate: selectedRenewalEndDate,
      })
      .then((commissionSchedule) => {
        setCommissionScheduleData(commissionSchedule);
      });
  };

  useEffect(() => {
    if (commissionScheduleData) {
      let commissionScheduleTotals = [];
      let commissionScheduleCompanyTotals = [];
      let commissionScheduleTypes = [];

      if (commissionScheduleData.types) {
        commissionScheduleData.types.forEach((commissionType, commissionTypeKey) => {
          let _type = {
            type: commissionType.type,
            companies: [],
            values: [],
          };

          commissionScheduleTypes.push(_type);

          if (commissionType.companies && commissionType.companies.length > 0) {
            commissionType.companies.forEach((company, companyKey) => {
              let selectedCompany = {
                name: commissionType.type + company.name,
                values: [],
              };

              let _company = {
                id: company.id,
                name: company.name,
                policies: [],
              };

              commissionScheduleCompanyTotals.push(selectedCompany);

              company.policies.forEach((policy, policyKey) => {
                // && policy.commission.schedule
                if (
                  policy.commission &&
                  (policy.policyStatus === 'Active' ||
                    (commissionIncludePending && policy.policyStatus === 'Pending'))
                ) {
                  _company.policies.push(policy);

                  if (policy.commission.schedule) {
                    policy.commission.schedule.forEach((scheduleMonth, scheduleMonthIndex) => {
                      if (!commissionScheduleTotals[scheduleMonthIndex]) {
                        commissionScheduleTotals[scheduleMonthIndex] = 0;
                      }

                      if (!_type.values[scheduleMonthIndex]) {
                        _type.values[scheduleMonthIndex] = 0;
                      }

                      if (!selectedCompany.values[scheduleMonthIndex]) {
                        selectedCompany.values[scheduleMonthIndex] = 0;
                      }

                      let parsedValue = parseFloat(scheduleMonth.value);

                      _type.values[scheduleMonthIndex] += parsedValue;
                      selectedCompany.values[scheduleMonthIndex] += parsedValue;
                      commissionScheduleTotals[scheduleMonthIndex] += parsedValue;
                    });
                  } else {
                  }
                }
              });

              if (_company.policies.length > 0) {
                _type.companies.push(_company);
              }
            });
          }
        });
      }

      setCommissionScheduleMonths(commissionScheduleData.months);
      setCommissionSchedule(commissionScheduleTypes);
      setCommissionScheduleTotals(commissionScheduleTotals);
      setCommissionScheduleCompanyTotals(commissionScheduleCompanyTotals);
    }
  }, [commissionScheduleData, commissionIncludePending]);

  return (
    <>
      <StyledModal
        size="lg"
        title="Edit Policy"
        footerCloseButton={true}
        show={editPolicyModalShow}
        onClose={(e) => setEditPolicyModalShow(false)}
      >
        <div className="row">
          <div className="col-12">
            <i className="far fa-user-circle text-primary mr-1"></i>
            {editingPolicyData.indName}
          </div>
          <div className="col-12 mb-3">
            <span className="badge badge-info">{editingPolicyData.planName}</span>
          </div>
          <div className="col-6">
            <label htmlFor="" className="label">
              Premium
            </label>
            <input
              type="text"
              name="policyPremium"
              value={editedPolicy?.policyPremium ?? 0.0}
              className="form-control form-control-sm"
              onChange={(e) => handlePolicyEdited(e)}
            />
          </div>
          <div className="col-6">
            <label htmlFor="" className="label">
              Commissionable Premium
            </label>
            <input
              type="text"
              name="policyComPrem"
              value={editedPolicy?.policyComPrem ?? 0.0}
              className="form-control form-control-sm"
              onChange={(e) => handlePolicyEdited(e)}
            />
          </div>
          <div className="col-12 mt-3">
            <div
              className="btn btn-sm btn-primary"
              onClick={() =>
                handleUpdatePolicy(
                  editingPolicyData.indId,
                  editingPolicyData.policyId,
                  editedPolicy
                )
              }
            >
              {isUpdating && (
                <>
                  <i className="far fa-spinner fa-spin mr-1"></i>Updating...
                </>
              )}
              {!isUpdating && <>Update</>}
            </div>
          </div>
        </div>
      </StyledModal>
      <div className="row">
        <div className="col-sm-12 col-md-12 px-2 sm-resp">
          <div className="card card-tall">
            <div className="card-header font-weight-bold py-2">Renewals Schedule</div>
            <div className="card-body pt-1" id="schShow">
              {commissionSchedule && commissionSchedule.length > 0 && (
                <>
                  <button
                    onClick={(e) => {
                      handleGetUserCommissionScheduleExport();
                    }}
                    className={['btn', 'btn-sm', 'btn-secondary', 'mr-2'].join(' ')}
                  >
                    {commissionScheduleExporting && <i className="fal fa-spinner fa-spin"></i>}
                    {!commissionScheduleExporting && <>Export</>}
                  </button>

                  <button
                    className={[
                      'btn',
                      'btn-sm',
                      commissionIncludePending ? 'btn-success' : 'btn-secondary',
                    ].join(' ')}
                    onClick={(e) => {
                      setCommissionIncludePending(!commissionIncludePending);
                    }}
                  >
                    Include Pending?
                  </button>
                  <div className="badge badge-info ml-2 cp">
                    <CommissionButton
                      userId={props.userId}
                      userAccessToken={props.userAccessToken}
                      buttonText={'Commission Schedules'}
                      onSave={handleSave}
                    />
                  </div>
                  <div>
                    <label htmlFor="monthPicker" className="label mt-2">
                      Select Start Date:
                    </label>
                    <input
                      type="date"
                      className="keep form-control form-control-sm needsSlashes w-auto"
                      value={selectedRenewalStartDate}
                      onChange={handleSelectRenewalStartDate}
                      required
                    />
                  </div>
                  <table
                    className="table table-sm  table-borderless  header-fixed dataTable no-footer"
                    data-toggle="table"
                    id="renewalScheduleTable"
                  >
                    <thead>
                      <tr>
                        <th colSpan={3}></th>
                        <th data-field="eff">Effective</th>
                        {commissionScheduleMonths &&
                          commissionScheduleMonths.map((month) => (
                            <th
                              className="text-right"
                              key={`months-${month}`}
                              data-sortable="true"
                              data-field="effDate"
                            >
                              {month}
                            </th>
                          ))}
                      </tr>
                    </thead>

                    <tbody sx={{ overflow: 'auto' }}>
                      <tr>
                        <td colSpan={3}></td>
                        <td>
                          <b>Totals</b>
                        </td>
                        {commissionScheduleTotals &&
                          commissionScheduleTotals.map((totalSingle, totalSingleIndex) => (
                            <td
                              key={`total-${totalSingleIndex}-${totalSingle}`}
                              className={
                                'text-right font-weight-bold py-2 text-success renTotal' +
                                totalSingleIndex
                              }
                            >
                              {formatter.format(totalSingle)}
                            </td>
                          ))}
                      </tr>

                      {commissionSchedule &&
                        commissionSchedule.map((commissionType, commissionTypeKey) => (
                          <Fragment key={commissionTypeKey}>
                            <tr
                              className="font-weight-bold border-bottom bg-secondary text-white title"
                              sx={{ fontSize: '11pt' }}
                            >
                              <td colSpan={3} className="pt-2">
                                {commissionType.type}{' '}
                                <span
                                  className="badge badge-primary float-right cp"
                                  onClick={(e) => {
                                    toggleVisibleSection(commissionType.type);
                                  }}
                                >
                                  {visibleSections.includes(commissionType.type) ? 'Hide' : 'Show'}
                                </span>
                              </td>
                              <td>
                                <b></b>
                              </td>
                              {commissionType.values &&
                                commissionType.values.map((totalSingle, totalSingleIndex) => (
                                  <td
                                    key={`${commissionType.type}-${totalSingle}-${totalSingleIndex}`}
                                    className="text-right font-weight-bold"
                                  >
                                    {formatter.format(totalSingle)}
                                  </td>
                                ))}
                            </tr>
                            {visibleSections.includes(commissionType.type) &&
                              commissionType.companies &&
                              commissionType.companies.length > 0 &&
                              commissionType.companies.map((company, companyKey) => (
                                <>
                                  <tr
                                    key={`${commissionType.type}-${company.name}-${companyKey}`}
                                    className="text-primary"
                                  >
                                    <td colSpan={3} className="border-info py-2">
                                      <b>{company.name}</b>{' '}
                                      <span
                                        className="badge badge-secondary float-right cp"
                                        onClick={(e) => {
                                          toggleVisibleSection(commissionType.type + company.name);
                                        }}
                                      >
                                        {visibleSections.includes(
                                          commissionType.type + company.name
                                        )
                                          ? 'Hide'
                                          : 'Show'}
                                      </span>
                                    </td>
                                    {commissionScheduleCompanyTotals &&
                                      commissionScheduleCompanyTotals.find(
                                        (companyTotals) =>
                                          companyTotals.name === commissionType.type + company.name
                                      ) && (
                                        <>
                                          <td className="border-right">
                                            <b></b>
                                          </td>
                                          {commissionScheduleCompanyTotals
                                            .find(
                                              (companyTotals) =>
                                                companyTotals.name ===
                                                commissionType.type + company.name
                                            )
                                            .values.map((totalSingle, totalSingleIndex) => (
                                              <td
                                                key={`total-${commissionType.type}-${company.name}-${totalSingleIndex}-${totalSingle.toFixed(2)}`}
                                                className="text-right font-weight-bold"
                                              >
                                                {formatter.format(totalSingle)}
                                              </td>
                                            ))}
                                        </>
                                      )}
                                  </tr>
                                  {visibleSections.includes(commissionType.type + company.name) &&
                                    company.policies &&
                                    (() => {
                                      const renderedPlanNames = new Set();
                                      const bandAlertPlanNames = new Set();

                                      return company.policies.map((policy, policyKey) => {
                                        const planName = policy.policy.name;
                                        let noCompPrem = false;
                                        const shouldRenderCommissionButton =
                                          policy?.commission?.errors?.includes(
                                            'No matching commissions'
                                          ) && !renderedPlanNames.has(company.name + planName);

                                        if (shouldRenderCommissionButton) {
                                          renderedPlanNames.add(company.name + planName);
                                        }

                                        if (
                                          parseInt(policy.policy.commissionablePremium) === 0 &&
                                          !policy?.commission?.errors?.includes(
                                            'No matching commissions'
                                          ) &&
                                          ['SUP', 'ANC', 'LIFE'].includes(commissionType.type) &&
                                          policy?.debug?.['Payment Type'] === 'Percentage'
                                        ) {
                                          noCompPrem = true;
                                        }

                                        const shouldShowMoreBandsAlert =
                                          policy.commission.schedule &&
                                          scheduleDefaultMonthCount >
                                            policy.commission.schedule.length &&
                                          !noCompPrem &&
                                          !bandAlertPlanNames.has(
                                            company.name +
                                              planName +
                                              policy.policyEffectiveFormatted
                                          );

                                        if (shouldShowMoreBandsAlert) {
                                          bandAlertPlanNames.add(
                                            company.name +
                                              planName +
                                              policy.policyEffectiveFormatted
                                          );
                                        }

                                        return (
                                          <tr key={`${policy.ind.id}-${policy.policy.id}`}>
                                            <td>
                                              <a
                                                href={`/agent/ProfileController/index/${policy.ind.id}`}
                                              >
                                                <i className="fas fa-user-circle cp text-primary"></i>
                                              </a>
                                            </td>
                                            <td>
                                              <i>{policy.ind.name}</i>
                                              {policy?.commission?.debug?.['Policy Initial Comp'] >
                                                0 && (
                                                <OverlayTrigger
                                                  placement="right"
                                                  overlay={
                                                    <Tooltip placement="right">
                                                      You have a manual commission value on this
                                                      policy, this overwrites any applicable comp
                                                      schedule.
                                                    </Tooltip>
                                                  }
                                                >
                                                  <i className="fas fa-info-circle text-warning ml-1 cp"></i>
                                                </OverlayTrigger>
                                              )}
                                            </td>
                                            <td>
                                              {policy.commission.isBeingReplaced && (
                                                <OverlayTrigger
                                                  placement="right"
                                                  overlay={
                                                    <Tooltip placement="right">
                                                      This policy is being replaced.
                                                    </Tooltip>
                                                  }
                                                >
                                                  <i className="fas fa-stop-circle text-danger mr-1 cp"></i>
                                                </OverlayTrigger>
                                              )}
                                              {policy.policyStatus === 'Pending' && (
                                                <OverlayTrigger
                                                  placement="right"
                                                  overlay={
                                                    <Tooltip placement="right">
                                                      This policy is pending.
                                                    </Tooltip>
                                                  }
                                                >
                                                  <i className="fas fa-clock text-info mr-1 cp"></i>
                                                </OverlayTrigger>
                                              )}

                                              {noCompPrem && (
                                                <OverlayTrigger
                                                  placement="right"
                                                  overlay={
                                                    <Tooltip placement="right">
                                                      No commissionable premium on policy. Click to
                                                      generate value.
                                                    </Tooltip>
                                                  }
                                                >
                                                  <i
                                                    className="fas fa-exclamation-circle text-warning mr-1 cp"
                                                    onClick={() =>
                                                      handleFetchPolicy(
                                                        policy.ind.id,
                                                        policy.policy.id,
                                                        policy.policy.name,
                                                        policy.ind.name
                                                      )
                                                    }
                                                  ></i>
                                                </OverlayTrigger>
                                              )}

                                              {planName}
                                            </td>
                                            <td className="border-right moneyTr">
                                              {policy.policyEffectiveFormatted}
                                            </td>
                                            {policy.commission.schedule &&
                                              policy.commission.schedule.map(
                                                (scheduleMonth, scheduleMonthIndex) => (
                                                  <td
                                                    key={`${commissionType.type}-${policy.policy.id}-${scheduleMonthIndex}`}
                                                    className={`text-right moneyTd moneyTd${scheduleMonthIndex}`}
                                                  >
                                                    {formatter.format(scheduleMonth.value)}
                                                  </td>
                                                )
                                              )}
                                            {shouldShowMoreBandsAlert && (
                                              <td>
                                                <span className="badge badge-info cp">
                                                  <CommissionButton
                                                    userId={props.userId}
                                                    userAccessToken={props.userAccessToken}
                                                    buttonText={'Add bands'}
                                                    onSave={handleSave}
                                                    selectedCommissionType={commissionType.type}
                                                  />
                                                </span>
                                              </td>
                                            )}
                                            {shouldRenderCommissionButton && (
                                              <td>
                                                <div className="badge badge-info ml-2 cp">
                                                  <CommissionButton
                                                    userId={props.userId}
                                                    userAccessToken={props.userAccessToken}
                                                    buttonText={'Set up schedule'}
                                                    onSave={handleSave}
                                                    selectedCommissionType={commissionType.type}
                                                  />
                                                </div>
                                              </td>
                                            )}
                                          </tr>
                                        );
                                      });
                                    })()}
                                </>
                              ))}
                          </Fragment>
                        ))}
                    </tbody>
                  </table>
                </>
              )}
              {!commissionSchedule && <Loader size="large" />}
              {commissionSchedule && commissionSchedule.length === 0 && (
                <div data-alert className="alert alert-info mx-3 mb-0">
                  Not enough data to show this chart.
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
